import { render, staticRenderFns } from "./AvailableAppointment.vue?vue&type=template&id=38c542c4"
import script from "./AvailableAppointment.vue?vue&type=script&lang=js"
export * from "./AvailableAppointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports